import React from 'react'
import RegistrationComponent from '../Components/RegistrationComponent'
import LoginComponent from '../Components/LoginComponent'
import CandidateHeader, {  } from '../../Candidate/Components/CandidateHeaderComponent'
import CandidateHeaderComponent from '../../Candidate/Components/CandidateHeaderComponent'
import { LandingHeader } from '../../LandingScreens/Components/LandingHeader'

function LoginPage() {
  return (
    <div>
      <LandingHeader/>
      <LoginComponent/>
        
    </div>
  )
}

export default LoginPage